import { apiFetch } from './client';

export interface GenerateMigrationGuideResponse {
  status: 'accepted';
  message: string;
}

/**
 * Kicks off migration-guide generation for a version.
 *
 * Returns 202 immediately — the actual generation runs asynchronously and can
 * take minutes. Poll `listVersions()` and watch for `migrationGuideS3Key` on
 * the version record to detect completion.
 */
export const generateMigrationGuide = (apiId: string, versionId: string) =>
  apiFetch<GenerateMigrationGuideResponse>(
    `/api/v1/apis/${apiId}/versions/${encodeURIComponent(versionId)}/migration-guide/generate`,
    { method: 'POST' },
  );
